<nw-content-block [border]="border" [heading]="title">
    <div class="nw-youtube-block__container">
        @if (topcontent) {
            <div
                [innerHTML]="topcontent | sanitizeHtml"
                [class.margin-bottom-xl]="!bottomcontent && !youtubeid"
            ></div>
        }
        @if (youtubeid) {
            <div class="margin-bottom-xl margin-top-xl">
                <iframe
                    #iframe
                    class="nw-youtube-block__container__iframe"
                    width="100%"
                    [height]="iframeHeight$$()"
                    [src]="
                        'https://www.youtube-nocookie.com/embed/' + youtubeid
                            | sanitizeUrl
                    "
                    title="YouTube video player"
                    frameborder="0"
                    allow="
                        accelerometer;
                        autoplay;
                        clipboard-write;
                        encrypted-media;
                        gyroscope;
                        picture-in-picture;
                        web-share;
                    "
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                ></iframe>
            </div>
        }
        @if (bottomcontent) {
            <div [innerHTML]="bottomcontent | sanitizeHtml"></div>
        }
    </div>
</nw-content-block>
